<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />

    <v-snackbar v-model="showSnackBar" color="#FF1313" left :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-container class="px-2 px-sm-4 py-6">
      <v-row>
        <v-col cols="12" class="pb-2">
          <h1 class="orders-title">Your Orders</h1>
        </v-col>
      </v-row>

      <v-row class="mb-4">
        <v-col cols="12">
          <div class="filter-wrapper">
            <v-btn
              v-for="filter in filters"
              :key="filter.type"
              :to="'/Orders?type=' + filter.type"
              depressed
              rounded
              class="filter-btn mr-2 mb-2"
              :color="$route.query.type === filter.type ? '#3EA56E' : '#F1F5F9'"
              :class="{ 'active-filter': $route.query.type === filter.type }"
            >
              {{ filter.label }}
            </v-btn>
          </div>
        </v-col>
      </v-row>

      <v-row v-if="products.length > 0">
        <v-col
          cols="12"
          v-for="(item, i) in products"
          :key="i"
          class="pa-0 mb-4"
        >
          <v-card flat class="order-card">
            <OrdersItem :storage="item" @stepper="winStepper" />
          </v-card>
        </v-col>
      </v-row>

      <v-row v-else-if="!appLoading" justify="center" class="py-12">
        <v-col cols="12" sm="8" md="6" class="text-center">
          <v-icon size="80" color="#CBD5E1">mdi-package-variant-closed</v-icon>
          <h3 class="no-orders-text mt-4">Oops! No orders found</h3>
          <p class="no-orders-subtext">Looks like you haven't placed any orders yet.</p>
          <v-btn color="#3EA56E" dark depressed rounded large to="/" class="mt-4 px-8">
            Start Shopping
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="products.length > 0" class="mt-6">
        <v-col cols="12">
          <v-pagination
            v-model="page"
            :length="Pagelength"
            :total-visible="7"
            color="#3EA56E"
            class="custom-pagination"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>
<script>
import axios from "axios";
import OrdersItem from "./ordersItem";
export default {
  components: {
    OrdersItem,
  },
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      products: [],
      ServerError: false,
      searchKey: null,
      page: 1,
      Pagelength: 0,
      limit: 20,
      filters: [
        { label: "All Orders", type: "Active" },
        { label: "Active", type: "all" },
        { label: "Delivered", type: "Delivered" },
        { label: "Cancelled", type: "Cancelled" },
      ],
    };
  },
  beforeMount() {
    this.setMetaTags();
    this.getData();
  },
   watch: {
    page() {
      this.getData();
    },
  },
  methods: {
    setMetaTags() {
      document.title = "My Orders | KL-06 FARM";
      let metaDescription = document.querySelector('meta[name="description"]');
      const description = "View and manage your recent orders, track shipments, and check delivery status at KL-06 FARM.";
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = description;
        document.head.appendChild(metaDescription);
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/my/orders/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          orderStatus: this.$route.query.type,
           page: this.page,
          limit: this.limit ,
          // filterType: "today",
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.data;
            this.Pagelength = Math.ceil(response.data.totalLength / this.limit);
          } else {
            this.products = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
     formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = day + " " + dt.slice(4, 7) + " " + year;
      return strTime;
    },
    winStepper(item) {
      if (item.getData) {
        this.getData();
      }
      this.msg = item.response.msg;
      this.showSnackBar = true;
    },
    appSearch() {},
  },
};
</script>

<style scoped>
.orders-title {
  font-family: "poppinssemibold", sans-serif;
  font-size: 24px;
  color: #1e293b;
  margin-bottom: 8px;
}

.filter-wrapper {
  display: flex;
  overflow-x: auto;
  padding-bottom: 8px;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.filter-wrapper::-webkit-scrollbar {
  display: none;
}

.filter-btn {
  font-family: "poppinsmedium", sans-serif;
  text-transform: none;
  letter-spacing: 0.3px;
  font-size: 14px;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
}

.active-filter {
  color: white !important;
  border-color: #3ea56e !important;
}

.order-card {
  border: 1px solid #f1f5f9;
  border-radius: 12px !important;
  padding: 16px;
  transition: all 0.3s ease;
}

.order-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border-color: #e2e8f0;
}

.no-orders-text {
  font-family: "poppinssemibold", sans-serif;
  font-size: 20px;
  color: #475569;
}

.no-orders-subtext {
  font-family: "poppinsregular", sans-serif;
  font-size: 15px;
  color: #94a3b8;
}

.custom-pagination ::v-deep .v-pagination__item {
  border-radius: 8px;
  box-shadow: none !important;
  border: 1px solid #e2e8f0;
}

.custom-pagination ::v-deep .v-pagination__item--active {
  border-color: #3ea56e;
}

@media (max-width: 600px) {
  .orders-title {
    font-size: 20px;
  }
}
</style>
